export default __webpack_public_path__ + "static/char-s-13-en-aabc257e78261f8f187ebc35d7bb069e.webp";